<template>
  <div class="vcl-link-house">
    <h3 class="vcl-logon__title">{{ $t('setupAccount') }}</h3>
    <p class="vcl-logon__description">{{ $t('justNeedAFewDetails') }}</p>
    <div class="vcl-link-house__name">
      <vp-input
        v-model="firstName"
        class="mb19"
        width="100%"
        height="50px"
        :placeholder="$t('enterFirstName')"
        type="email"
        required
        :styles="inputStyles"
      >
        <template #label>{{ $t('firstName') }}</template>
      </vp-input>
      <vp-input
        v-model="lastName"
        class="mb19"
        width="100%"
        height="50px"
        :placeholder="$t('enterLastName')"
        type="text"
        required
        :styles="inputStyles"
      >
        <template #label>{{ $t('lastName') }}</template>
      </vp-input>
    </div>
    <vp-input
      v-model="email"
      class="mb19"
      width="100%"
      height="50px"
      :placeholder="$t('enterEmail')"
      type="text"
      required
      :styles="inputStyles"
    >
      <template #label>{{ $t('email') }}</template>
    </vp-input>
    <vp-button
      class="vcl-logon__button primary large"
      :disabled="!firstName || !lastName || !email"
      :styles="buttonStyles"
      @click="linkAccount"
    >
      {{ $t('setupAccount') }}
    </vp-button>
  </div>
</template>
<script>
// General Components
import VpInput from '../../components/vp-input/VpInput.vue';
import VpButton from '../../components/vp-button/VpButton.vue';

export default {
  name: 'VpLinkHouse',
  components: {
    VpInput,
    VpButton,
  },
  inject: ['$busy'],
  props: {
    styles: {
      type: Object,
      default() {
        return {};
      },
    }
  },
  data() {
    return {
      firstName: null,
      lastName: null,
      email: null,
      houseLink: null,
    };
  },
  computed: {
    inputStyles() {
      return this.styles.input || {};
    },
    buttonStyles() {
      return this.styles.button || {};
    },
  },
  mounted() {
    this.$busy.on(true);
    const { logon } = this.$deps;
    this.houseLink = this.$route.query['house-link'];

    // in vuepress we won't have the process object, so return
    if ((typeof process) === 'undefined') {
      this.$busy.on(false);
      return;
    }

    if (!this.houseLink) {
      this.$router.push('/logon');
    } else {
      // checking for 404 with the catch block
      logon.getHouseLink(this.houseLink).then(() => {
        this.$busy.on(false);
      }).catch(() => {
        this.$router.push('/logon');
      });
    }
  },
  methods: {
    linkAccount() {
      this.$busy.on(true);
      const { logon } = this.$deps;
      const opts = {
        houseLink: this.houseLink,
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
      };

      return logon.linkAccount(opts)
        .then(() => {
          const successQuery = {
            title: 'i18n:youAreAllSet',
            message: 'i18n:checkYourEmailForSpecialLink',
            backButton: false,
          };

          return this.$router.push({ path: '/logon/success', query: successQuery });
        })
        .catch(() => {
          return this.$router.push({ path: '/logon/error', query: {} });
        })
        .finally(() => {
          this.$busy.on(false);
        });
    },
  }
};
</script>

<style lang="scss">
  @import "../../styles/mixins.scss";

  .vcl-link-house {
    margin: 0;
    padding: 34px 30px 0px;
    &__name {
      display: flex;
      column-gap: 1em;
      margin-top: 30px;
    }
     @include Tablet {
      padding: 10px 47px 0px;
      .vcl-logon__description {
        margin-bottom: 37px;
      }
    }
  }
</style>
